'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _youtube = require('../../../molecules/youtube');

var _youtube2 = _interopRequireDefault(_youtube);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'video-section';

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.getAlignment = function (textAlign) {
      var alignment = {
        left: ORGANISM_NAME + '__container col-xs-12 text-xs-left',
        center: ORGANISM_NAME + '__container col-xs-12 center-block text-xs-center'
      };

      return alignment[textAlign] || alignment.left;
    };

    _this.handleResize = function () {
      var newWindowWidth = _this.organismRef.ownerDocument.defaultView.innerWidth || _this.organismRef.ownerDocument.documentElement.clientWidth || _this.organismRef.ownerDocument.body.clientWidth;

      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (_this.state.isMobile || _this.state.xSmall) {
          _this.setState({
            isMobile: false,
            xSmall: false
          });
        }
      } else if (newWindowWidth >= _breakpoints2.default.small) {
        if (_this.state.isMobile || !_this.state.xSmall) {
          _this.setState({
            isMobile: true,
            xSmall: false
          });
        }
      } else if (!_this.state.isMobile || !_this.state.xSmall) {
        _this.setState({
          isMobile: true,
          xSmall: true
        });
      }
    };

    _this.handleScroll = function () {
      window.removeEventListener('scroll', _this.handleScroll);
      _this.enableVideo();
    };

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: 2, className: ORGANISM_NAME + '__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.renderParagraph = function (paragraph) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__paragraph' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    };

    _this.renderCta = function (cta, color) {
      if (cta && cta.text) {
        var targetValue = cta.target || '_self';
        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            color: color || cta.color || undefined,
            className: ORGANISM_NAME + '__btn',
            fpti: 'Video-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    };

    _this.renderHatchText = function (hatchText, isCentered) {
      if (hatchText && hatchText.text) {
        var classes = (0, _classnames2.default)(ORGANISM_NAME + '__hatch-text pp-sans-small-regular', _defineProperty({}, ORGANISM_NAME + '__hatch-text--center', isCentered));

        return _react2.default.createElement(
          'p',
          { className: classes },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    };

    _this.state = {
      showVideo: false,
      isMobile: false,
      xSmall: false
    };
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();

      // if video component is in the window view, then enable video immediately,
      // otherwise add a listener and enable video only after user scroll.
      var domRect = this.organismRef && this.organismRef.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableVideo();
      } else {
        window.addEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'enableVideo',
    value: function enableVideo() {
      this.setState({
        showVideo: true
      });
    }
  }, {
    key: 'renderVideo',
    value: function renderVideo(video) {
      if (video && this.state.showVideo) {
        return _react2.default.createElement(_youtube2.default, {
          className: '' + ORGANISM_NAME,
          videoId: video.videoId,
          width: 515,
          height: 290,
          isMobile: this.state.isMobile,
          autoplay: this.state.isMobile ? 0 : video.autoplay
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var theme = this.props.config.theme || 'theme-background-color-white';
      var newProps = (0, _themeManager2.default)(this.props, theme);

      var config = newProps.config,
          content = newProps.content,
          className = newProps.className;
      var headline = content.headline,
          paragraph = content.paragraph,
          primaryCta = content.primaryCta,
          video = content.video,
          hatchText = content.hatchText;
      var id = config.id;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME, className, theme);

      return _react2.default.createElement(
        'section',
        {
          ref: function ref(c) {
            _this2.organismRef = c;
          },
          id: id,
          className: sectionClasses,
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            paragraph && paragraph.text ? _react2.default.createElement(
              'div',
              null,
              !this.state.isMobile && config.textAlign === 'right' && _react2.default.createElement(
                'div',
                { className: 'col-md-6 col-sm-12' },
                this.renderVideo(video)
              ),
              _react2.default.createElement(
                'div',
                { className: ORGANISM_NAME + '__content col-md-6 col-sm-12' },
                this.renderHeadline(headline),
                this.renderParagraph(paragraph),
                this.state.isMobile && !this.state.xSmall && _react2.default.createElement(
                  'div',
                  null,
                  this.renderVideo(video)
                ),
                this.renderCta(primaryCta),
                this.renderHatchText(hatchText, false)
              ),
              !this.state.isMobile && config.textAlign === 'left' && _react2.default.createElement(
                'div',
                { className: 'col-md-6 col-sm-12' },
                this.renderVideo(video)
              )
            ) : _react2.default.createElement(
              'div',
              { className: this.getAlignment('center') },
              this.renderHeadline(headline),
              this.renderVideo(video),
              this.renderCta(primaryCta),
              this.renderHatchText(hatchText, true)
            )
          )
        ),
        this.state.xSmall && config.textAlign !== 'center' && paragraph && paragraph.text && _react2.default.createElement(
          'div',
          { className: 'below-' + ORGANISM_NAME },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: ORGANISM_NAME + '__video-col col-sm-12' },
                this.renderVideo(video)
              )
            )
          )
        )
      );
    }
  }]);

  return Video;
}(_react2.default.Component);

// ESLint disabled because the PropTypes below are used, but
// they are processed before being used and ESLint does not detect that.


exports.default = Video;
Video.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-dark', 'theme-background-color-white', 'theme-background-color-light']).isRequired,
    textAlign: _propTypes2.default.oneOf(['right', 'left'])
  }),

  /* eslint-disable */
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    video: _propTypes2.default.shape({
      videoId: _propTypes2.default.string.isRequired,
      autoplay: _propTypes2.default.number
    }).isRequired,
    primaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
  /* eslint-enable */
};

Video.defaultProps = {
  config: {
    id: '',
    textAlign: 'right',
    theme: 'theme-background-color-white'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize ' + 'contrast with background image. 152 characters maximum.'
    },
    video: {
      id: '',
      videoId: 'lkz4GZgyb9o',
      autoplay: 0
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/video/jsx/Video.js
// module id = 1159
// module chunks = 4